<template>
  <el-dialog :close-on-click-modal="false" append-to-body v-model="visible" modal-class="is--form" 
  
  
  :title="$t(form.ID>0?`registration.payment.fapiao2`:`registration.payment.fapiao`)" width="720px" align-center>
  
   
    <el-form ref="formRefs" :model="form" label-position="top" :disabled="form.ID>0">
      <el-form-item>
        <vxe-table style="width: 100%" ref="tableRefs" :data="list" :border="'inner'" align="center">
          <vxe-column type="checkbox" width="50" fixed="left" align="center"></vxe-column>
         <vxe-column field="TicketName" :title="$t(`registration.payment.table-code`)" :min-width="150"></vxe-column>
          <vxe-column field="TicketPrice" :title="$t(`registration.payment.table-price`)" width="80"></vxe-column>
          <vxe-column field="Number" :title="$t(`registration.payment.table-number`)" width="80"></vxe-column>
          <vxe-column field="Total" :title="$t(`registration.payment.table-money`)" width="80"></vxe-column>
        </vxe-table>
      </el-form-item>

      <el-form-item
        :label="$t(`registration.inovice.title`)"
        prop="InvoiceTitle"
        :rules="[
          {
            required: true,
            message: $t('registration.form.required', { title: $t('registration.inovice.title') }),
          },
        ]"
      >
        <el-input v-model="form.InvoiceTitle"></el-input>
      </el-form-item>

      <el-form-item
        :label="$t(`registration.inovice.no`)"
        :rules="[
          {
            required: true,
            message: $t('registration.form.required', { title: $t('registration.inovice.no') }),
          },
        ]"
      >
        <el-input v-model="form.InvoiceNo"></el-input>
      </el-form-item>

      <el-form-item :label="$t(`registration.inovice.person`)">
        <el-input v-model="form.ContactPerson"></el-input>
      </el-form-item>

      <el-form-item :label="$t(`registration.inovice.phone`)">
        <el-input v-model="form.ContactPhone"></el-input>
      </el-form-item>

      <el-form-item :label="$t(`registration.inovice.address`)">
        <el-input v-model="form.ContactAddress"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="visible = false">{{ $t(`registration.btn.cancel`) }}</el-button>
      <el-button v-if="!(form.ID>0)" type="primary" @click="handleSubmit">{{ $t(`registration.btn.ok`) }}</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
  import { handleError, onMounted, ref, defineExpose, inject, computed, nextTick } from 'vue'
  import { updateInovice, getInovice } from '@/api/registration'
  import { ElMessage, ElMessageBox,ElLoading  } from 'element-plus'
  import { useI18n } from 'vue-i18n'

  

  const { t, te } = useI18n()
  const visible = ref(false)
  const emit = defineEmits(['close', 'update'])
  const formRefs = ref(null)
  const tableRefs = ref(null)

  //
  const form = ref({ Order: [] })
  const row = ref({})
  const $order = inject('$order')

  const handleSubmit = async () => {
    let rows=tableRefs.value.getCheckboxRecords().map(x=>x.ID)
    if(rows.length==0){
      
      ElMessage({ message: t(`registration.inovice.error1`), type: 'error' })
      return
    }
    const loading=ElLoading.service({fullscreen:true})
    const { ret } = await updateInovice({...form.value,...{Order:rows}})
    loading.close()
    emit('update')
    visible.value = false
  }

  const list = computed(() => {
    let data = []
    console.log('$order', $order.value)
    if (form.value.ID > 0) {
      //只显示自己的
      for (var g of $order.value) {
        console.log(g)
        if (g.Status.toLocaleLowerCase() != 'ready') {
          if (form.value.Order.findIndex(x=>x.ID==g.ID) >= 0) {
            data.push(g)
          }
        }
      }
    } else {
      for (var g of $order.value) {
        console.log(g)
        if (g.Status.toLocaleLowerCase() != 'ready') {
          if (form.value.Order.findIndex(x=>x.ID==g.ID) >= 0 || (g.Inovice && g.Inovice.ID)) {
            data.push(g)
          }
        }
      }
    }
    console.log('data', $order.value, data, form.value)
    return data
  })

  defineExpose({
    show: async (rows) => {
      row.value = rows
      visible.value = true
      form.value = Object.assign({}, rows.Inovice || { ID: 0 })
      form.value.Order = []
      if (rows.Inovice&&rows.Inovice.ID) {
        for (var g of $order.value) {
          if (g.Inovice && rows.Inovice.ID == rows.Inovice.ID) {
            form.value.Order.push(g)
          }
        }
      } else {
        form.value.Order.push(rows)
      }
      console.log('form.value',form.value)
      nextTick(() => {
        tableRefs.value.setCheckboxRow(form.value.Order, true)
      })
    },
  })
</script>

<style lang="scss" scoped>
  .el-radio-group {
    .el-radio {
      width: 100%;
    }
  }
</style>
